import './style.sass';
import { Row, Col, Container, Button, Form } from 'react-bootstrap';
import QuizOption from '../../components/QuizOption';
import { Images } from '../../components';
import { useEffect, useState } from 'react';
import * as Actions from '../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { BeatLoader } from 'react-spinners';
import requestElementFullscreen from '../../common/utils';

export default function Step1({ updateCount }) {
  const dispatch = useDispatch();
  const [occupancyChecked, setOccupancyChecked] = useState(null);
  const [typeAnswer, setTypeAnswer] = useState(null);
  const [question, setQuestion] = useState({});
  const [mathInputValue, setMathInputValue] = useState('');
  const [tags, setTags] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [message, setMessage] = useState('Correct');
  const [alreadySubmittedAnswer, setAlreadySubmittedAnswer] = useState(null);
  const [isPassageLoading, setIsPassageLoading] = useState(false);
  const [
    currentUser,
    questionId,
    userQuizAnswer,
    questionState,
    userQuizId,
    isReviewNew,
    tagsIdState,
    tagsState,
    feedbackStatus,
    reviewStepsSubmitted,
  ] = useSelector((state) => {
    return [
      state.auth.cognito,
      state.review.questionId,
      state.review.userQuizAnswer,
      state.review.singleQuestion,
      state.review.userQuizId,
      state.review.isReviewNew,
      state.review.tags,
      state.review.tagsResponse,
      state.review.feedbackStatus,
      state.review.reviewStepsSubmitted,
    ];
  });

  const isValidSPRInput = (input) => {
    if (input === '' || input === '-') return true;

    const pattern = /^-?(\d*(\.\d*)?|\d+\/\d*)$/;

    if (!pattern.test(input)) {
      return false;
    }

    const digits = input.replace(/[^0-9]/g, '');
    return digits.length <= 6;
  };

  const handleMathInputChange = (event) => {
    event.stopPropagation();
    const { value } = event.target;
    if (isValidSPRInput(value)) {
      setMathInputValue(value);
    }
  };

  useEffect(() => {
    setOccupancyChecked(mathInputValue || null);
  }, [mathInputValue]);

  useEffect(() => {
    if (questionId && userQuizAnswer) {
      dispatch(Actions.dispatchGetQuestion(questionId));
      setOccupancyChecked(userQuizAnswer);
      setMathInputValue(userQuizAnswer?.toLowerCase() === 'skip' ? '' : userQuizAnswer || '');
    }
  }, [questionId, userQuizAnswer, dispatch]);

  useEffect(() => {
    if (reviewStepsSubmitted) {
      if (reviewStepsSubmitted?.length > 0) {
        setTypeAnswer(reviewStepsSubmitted[0]?.answer);
        setAlreadySubmittedAnswer(reviewStepsSubmitted[0]?.answer);
      }
    }
  }, [reviewStepsSubmitted]);

  useEffect(() => {
    if (tagsIdState) {
      dispatch(Actions.dispatchGetTag(tagsIdState?.topicId));
    }
  }, [tagsIdState, dispatch]);

  useEffect(() => {
    if (tagsState && questionState) {
      var tempTags = [];
      const shuffledItems = shuffleArray(tagsState?.descendants?.items);
      shuffledItems?.map((item) => {
        tempTags.push({
          id: item?.id,
          title: item?.title,
        });
      });
      if (tempTags.length >= 4) {
        tempTags.slice(0, 4);
      }
      tempTags.push({
        id: tagsIdState?.subtopicId,
        title: tagsIdState?.subtopic,
      });
      const shuffledItemsTemp = shuffleArray(tempTags);
      const uniqueData = [];
      const uniqueTitles = new Set();

      shuffledItemsTemp.forEach((item) => {
        if (!uniqueTitles.has(item.title)) {
          uniqueTitles.add(item.title);
          uniqueData.push(item);
        }
      });
      setTags(uniqueData);
    }
  }, [tagsState, questionState, dispatch, tagsIdState]);

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  useEffect(() => {
    if (questionState) {
      setIsPassageLoading(true);
      setQuestion(questionState);
      setTimeout(() => {
        var doc = [];
        doc = document.getElementsByClassName('line-ref');
        var inputList = Array.prototype.slice.call(doc);
        inputList?.map((item) => {
          try {
            var result = item.innerText.substring(6, item.innerText.length - 1);
            const getLine = document.getElementById(`${result}_start`).nextSibling;
            item.innerHTML = `<a data-tip="${getLine.textContent}" onclick="onLineRefClicked('${result}_start_highlight')" href="#${result}_start">line</a>`;
            document.getElementById(
              `${result}_start`,
            ).innerHTML = `<span id="${result}_start_highlight">${getLine.textContent}</span>`;
            document.getElementById(`${result}_start`).nextSibling.remove();
          } catch (err) {
            console.log('Error in line ref', err);
          }
        });
        setIsPassageLoading(false);
        ReactTooltip.rebuild();
      }, 800);
    }
  }, [questionState, userQuizAnswer]);

  return (
    <>
      <Container className="step-1">
        {question?.section?.title === 'Reading' && isPassageLoading && (
          <>
            <div className="text-center">
              <BeatLoader color={'#10A0DE'} size={30} loading={isPassageLoading} />
            </div>
          </>
        )}
        <Row
          style={{ marginRight: '0', marginBottom: '12px' }}
          className={`step-row ${
            question?.section?.title !== 'Reading' ? '' : isPassageLoading ? 'd-none' : ''
          }`}
        >
          <Col md={5} className="stepBox-wrapper">
            <div className="stepBox">
              <div style={{ display: 'flex' }}>
                <h1>{question?.orderId}.</h1>
                <div>
                  <h1
                    className="stepBoxText"
                    dangerouslySetInnerHTML={{
                      __html: question?.title,
                    }}
                  ></h1>
                  {question?.answer?.answerType === 'SINGLE_CORRECT' && (
                    <>
                      <div style={{ display: 'flex' }}>
                        <QuizOption
                          name={'question_option'}
                          label={'A'}
                          value={question?.answer?.choices[0]}
                          checked={occupancyChecked}
                          changeChecked={''}
                        />
                      </div>
                      <div style={{ display: 'flex' }}>
                        <QuizOption
                          name={'question_option'}
                          label={'B'}
                          value={question?.answer?.choices[1]}
                          checked={occupancyChecked}
                          changeChecked={''}
                        />
                      </div>
                      <div style={{ display: 'flex' }}>
                        <QuizOption
                          name={'question_option'}
                          label={'C'}
                          value={question?.answer?.choices[2]}
                          checked={occupancyChecked}
                          changeChecked={''}
                        />
                      </div>
                      <div style={{ display: 'flex' }}>
                        <QuizOption
                          name={'question_option'}
                          label={'D'}
                          value={question?.answer?.choices[3]}
                          checked={occupancyChecked}
                          changeChecked={''}
                        />
                      </div>
                    </>
                  )}
                  {question?.answer?.answerType === 'SPR' && (
                    <>
                      <div>
                        <Form
                          onSubmit={(event) => {
                            event.preventDefault();
                          }}
                        >
                          <Form.Group className="mb-3" controlId="formBasicMathInput">
                            <Form.Label>
                              {userQuizAnswer?.toLowerCase() === 'skip'
                                ? 'You had skipped this question'
                                : 'Your Answer'}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter your answer"
                              onChange={handleMathInputChange}
                              maxLength={6}
                              value={mathInputValue}
                              style={{ textAlign: 'right' }}
                            />
                            <Form.Text className="text-muted">
                              Accept numbers, [ - ], [ . ] or [ / ]
                              <div>Maximum input of 6 characters</div>
                              <div>
                                The input must be a valid number, and the leading zero before the
                                decimal point can be omitted.
                              </div>
                              <div>E.g., -.0088 and .0088 are both valid.</div>
                            </Form.Text>
                          </Form.Group>
                        </Form>
                      </div>
                      <div className="math_answer_wrapper">
                        <div>Answer preview:</div>
                        <span className="math_answer">
                          {(() => {
                            let displayValue = mathInputValue;
                            if (displayValue.startsWith('.')) {
                              displayValue = '0' + displayValue;
                            } else if (displayValue.startsWith('-.')) {
                              displayValue = '-0' + displayValue.slice(1);
                            }
                            if (displayValue.includes('/')) {
                              const parts = displayValue.split('/');
                              let sign = '';
                              let numerator = parts[0].trim();
                              let denominator = parts[1].trim();
                              if (numerator.startsWith('-')) {
                                sign = '-';
                                numerator = numerator.slice(1);
                              }
                              return (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  {sign && (
                                    <div
                                      style={{
                                        marginRight: '5px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: '100%',
                                      }}
                                    >
                                      {sign}
                                    </div>
                                  )}
                                  <div
                                    className="fraction"
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <div className="math_item">{numerator}</div>
                                    <hr style={{ width: '100%', margin: '0' }} />
                                    <div className="math_item">{denominator}</div>
                                  </div>
                                </div>
                              );
                            } else {
                              return <div className="math_item">{displayValue}</div>;
                            }
                          })()}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </Col>
          <Col style={{ background: ' #FFFFFF', paddingBottom: '16px' }} md={7}>
            <div className="categoryBox">
              <div>
                <h1 className="categoryBoxText">What question type is this?</h1>
                <br />
                {tags?.map((item) => (
                  <>
                    <div style={{ display: 'flex' }}>
                      <input
                        name="select"
                        style={{ width: '20px', height: '20px' }}
                        type="radio"
                        value={item?.title}
                        checked={typeAnswer === item?.title ? true : false}
                        disabled={alreadySubmittedAnswer ? true : false}
                        onChange={(e) => {
                          setTypeAnswer(e.target.value);
                          if (tagsIdState?.subtopic === e.target.value) {
                            setMessage('Correct');
                          } else {
                            setMessage('Incorrect');
                          }
                        }}
                      />
                      <p style={{ marginLeft: '8px' }}>{item?.title} </p>
                    </div>
                  </>
                ))}
                <br />
              </div>
              {!isSubmitted ? (
                <>
                  <Button
                    onClick={() => {
                      if (typeAnswer) {
                        if (feedbackStatus === 'FINISHED' || feedbackStatus === 'FLAGGED') {
                          updateCount();
                        } else {
                          dispatch(
                            Actions.saveReviewStep([
                              {
                                time: 20,
                                answer: typeAnswer,
                              },
                            ]),
                          );
                          setIsSubmitted(true);
                          if (!isReviewNew) {
                            dispatch(
                              Actions.dispatchUpdateReview({
                                userQuizId: userQuizId,
                                questionId: question?.id,
                                reviewFeedback: 'PENDING',
                                review: JSON.stringify([
                                  {
                                    time: 20,
                                    answer: typeAnswer,
                                  },
                                ]),
                              }),
                            );
                          } else {
                            dispatch(
                              Actions.dispatchCreateReview({
                                questionId: question?.id,
                                answer: 'Skip',
                                quizId: question?.quizId,
                                time: 10,
                                userId: currentUser?.username,
                                userQuizId: userQuizId,
                                reviewFeedback: 'PENDING',
                                review: JSON.stringify([
                                  {
                                    time: 20,
                                    answer: typeAnswer,
                                  },
                                ]),
                              }),
                            ).then(() => {
                              dispatch(Actions.saveReviewIfNew(false));
                            });
                          }
                        }
                      }
                    }}
                    style={{
                      background: '#4EA2E2',
                      border: 'none',
                      padding: '10px 50px',
                    }}
                    disabled={!typeAnswer}
                  >
                    {feedbackStatus === 'FINISHED' || feedbackStatus === 'FLAGGED'
                      ? 'Next'
                      : 'Submit'}
                  </Button>
                </>
              ) : null}
            </div>
            {isSubmitted && (
              <Col md={12} offset={0} className="offset-0" style={{ marginLeft: '20px' }}>
                <h4>{message}</h4>
                <h5>{message === 'Incorrect' ? <span>The correct category is</span> : null}</h5>
                {message === 'Incorrect' ? <h5>- {tagsIdState?.subtopic}</h5> : null}
                <Button
                  onClick={() => {
                    updateCount();
                  }}
                  style={{
                    background: '#4EA2E2',
                    border: 'none',
                    padding: '10px 50px',
                  }}
                >
                  Go to Step 2: Review Skills
                </Button>
              </Col>
            )}
          </Col>
        </Row>

        {!question?.passage?.direction &&
        !question?.passage?.attribution &&
        !question?.passage?.body ? null : (
          <div className="passageBox">
            <div className="right-action">
              <img
                alt="fullScreen"
                onClick={() => {
                  let element = document.getElementsByClassName('passageBox')[0];
                  requestElementFullscreen(element);
                }}
                src={Images.expandImage}
              />
            </div>
            <h1 className="passageBoxHeading"></h1>
            <h1 className="passageBoxHeading"></h1>
            <div>
              <>
                {question?.passage?.direction ? (
                  <>
                    <div
                      className={'title'}
                      dangerouslySetInnerHTML={{
                        __html: question?.passage?.direction,
                      }}
                    />
                  </>
                ) : null}

                {question?.passage?.attribution ? (
                  <div
                    className={'description'}
                    dangerouslySetInnerHTML={{
                      __html: question?.passage?.attribution,
                    }}
                  />
                ) : null}
                {question?.passage?.body ? (
                  <div
                    className={'description'}
                    dangerouslySetInnerHTML={{
                      __html: question?.passage?.body,
                    }}
                  />
                ) : null}
              </>
            </div>
          </div>
        )}
      </Container>
    </>
  );
}
